import React, { useState, useEffect, useCallback } from 'react';
import './ColumnInputFilter.scss';
import { useLocation } from 'react-router-dom';
import { Input } from 'antd/lib/index';
import cx from 'classnames';

export const ColumnInputFilter = (props) => {
  const { option, onChange, type } = props;
  const { id } = option;
  const location = useLocation();
  const { search } = location;
  const searchParams = new URLSearchParams(search);

  const [value, setValue] = useState(searchParams.get(id) || '');
  const [, setIsFocus] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [modifiedValue, setModifiedValue] = useState(null);

  const onChangeInputValue = (e) => {
    let value = e.target.value;

    if (e.target.type === 'number' || e.target.type === 'tel') {
      value = value.replaceAll(/[^0-9]/g, '');
    }

    setValue(value);
    setModifiedValue(value || null);
    setIsEdit(true);
  };
  const handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      onChange({ value, id: e.target.id });
    }
  };

  const onBlur = useCallback(() => {
    if (value === modifiedValue) setIsEdit(false);
    setIsFocus(false);
  }, [value, modifiedValue]);

  useEffect(() => {
    // 비제어 컴포넌트의 형식으로 작동되기 때문에, 검색 결과를 랜더링 후 값으로 받아오도록 해당 로직을 추가했습니다.
    setValue(searchParams.get(id) || '');
  }, [search]);

  return (
    <span className={cx('column-input-filter', { isEdit: isEdit })}>
      <Input
        type={type}
        id={id}
        value={value || ''}
        onChange={onChangeInputValue}
        onKeyUp={handleKeyUp}
        onBlur={onBlur}
        onFocus={() => setIsFocus(true)}
      />
    </span>
  );
};

export default ColumnInputFilter;
